import { useEffect, useState, memo } from 'react';
import QuestionDetail from '@/components/question-detail';
import { getGlobalStore } from '@/store/global';
import './index.scss';
import { useControlDrawerTransform } from '@/utils/custom-hooks';

const QuestionDetailDrawer = () => {
    const [type, setType] = useState<'pair_of_qa' | 'gbot'>('gbot');
    const [id, setId] = useState<any>();
    const { style, showDrawer, hideDrawer } = useControlDrawerTransform();

    const handleClose = () => {
        hideDrawer();
        setType('gbot');
        setId(undefined);
    };

    useEffect(() => {
        getGlobalStore()?.subscribe('QuestionDetailDrawer', (params: { type: string; askId: number; qaId: string }) => {
            switch (params.type) {
                case 'show':
                    setType(params.askId ? 'gbot' : 'pair_of_qa');
                    setId(params.askId || params.qaId);
                    showDrawer();
                    break;
                default:
                    handleClose();
                    break;
            }
        });
    }, []);

    return (
        <div className="similar-detail-drawer" style={style}>
            <QuestionDetail type={type} id={id} needToastInQa onClose={handleClose} />
        </div>
    );
};

export default memo(QuestionDetailDrawer);
